import production from './production';

/**
 * Override here which ever required
 * development.SSR_GQL_ENDPOINT = ""
 */

export default {
  ...production,
  IMAGE_CDN_DOMAIN: process.env.IMAGE_CDN_DOMAIN || 'https://teja8.kuikr.com',
  GA4_ID: process.env.GA4_ID || 'G-TDXMWQ59FL'
};
